import React, {
  useState,
  useCallback,
  Dispatch,
  SetStateAction,
  useContext,
} from "react";
import { useStyles } from "./CreditSimulator2.style";
import { Icon, useMediaQuery } from "@material-ui/core";
import { ButtonOutlined, ButtonPrimary } from "..";
import { navigate } from "@reach/router";
import { Route } from "@interfaces";
import { goIcon, targetIcon } from "@images";
import { AppContext } from "@context";

type Props = {
  setPage: Dispatch<SetStateAction<number>>;
  adjustDesktop?: React.CSSProperties;
  isMission?: boolean;
  monthPayment: number;
  term: number;
  rate: number;
  handleClick: () => void;
};

const CreditSimulator2: React.FC<Props> = ({
  setPage,
  adjustDesktop,
  isMission,
  monthPayment,
  term,
  rate,
  handleClick,
}) => {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 1240px)");
  const { openCongratsModal } = useContext(AppContext);

  const [values, setValues] = useState({
    amount: 0,
    time: 36,
    totalAmount: 0,
  });

  const handleChange = () => {
    navigate(Route.finance);
  };
  return (
    <div className={classes.container} style={adjustDesktop}>
      {!isMobile ? (
        <div className={classes.topSection}>
          <div className="item">
            <div className="description">
              <span className={classes.text}>
                Utilizando una
                <span className="style1"> tasa promedio </span>
                de:
              </span>
            </div>
            <div className="rateContainer">{rate * 100}%</div>
          </div>
          <div className="item">
            <div className="description">
              <span className={classes.text}>
                <span className="style1 enabled">Categoría del crédito</span>
              </span>
            </div>
            <div className="rateContainer enabled">Crédito de consumo</div>
          </div>
        </div>
      ) : (
        <div className={classes.topSection}>
          <div className="centrator">
            <div className="item">
              <div className="description">
                <span className={classes.text}>
                  Utilizando una
                  <span className="style1"> tasa promedio </span>
                  de:
                </span>
              </div>
              <div className="rateContainer">{rate * 100}%</div>
            </div>
            <div className="item">
              <div className="description">
                <span className={classes.text}>
                  <span className="style1 enabled">Categoría del crédito</span>
                </span>
              </div>
              <div className="rateContainer enabled">Crédito de consumo</div>
            </div>
          </div>
        </div>
      )}
      {!isMobile ? (
        <div className={classes.middleSection}>
          <div className="creditInfo">
            <span className="description">pagarás al mes</span>
            <span className="value">
              $ {Math.round(monthPayment).toLocaleString("es")}
            </span>
          </div>
          <div className="creditInfo">
            <span className="description">en cuanto Tiempo</span>
            <span className="value">{term} meses</span>
          </div>
          <div className="creditInfo">
            <span className="description">en total pagarás</span>
            <span className="value">
              $ {Math.round(term * monthPayment).toLocaleString("es")}
            </span>
          </div>
        </div>
      ) : (
        <div className={classes.middleSection}>
          <div className="centrator">
            <div className="creditInfo">
              <span className="description">pagarás al mes</span>
              <span className="value">
                $ {Math.round(monthPayment).toLocaleString("es")}
              </span>
            </div>
            <div className="creditInfo">
              <span className="description">en cuanto Tiempo</span>
              <span className="value">{term} meses</span>
            </div>
            <div className="creditInfo">
              <span className="description">en total pagarás</span>
              <span className="value">
                $ {Math.round(term * monthPayment).toLocaleString("es")}
              </span>
            </div>
          </div>
        </div>
      )}

      <div className={classes.secondMidSection}>
        <div className="firstText">
          <span>
            <strong>OJO </strong>
            Recuerda que es sólo una estimación en base a las tasas promedio que
            están ofreciendo las Entidades Financieras actualmente. Puede
            diferir de lo que te ofrezcan personalmente dependiendo de tu nivel
            de ingresos y capacidad crediticia.
          </span>
        </div>
        {isMission && (
          <div className="secondText">
            <div className="texasContainer">
              <img src={targetIcon} />
              <div className="textContainer">
                <span className="title">¿Ya tienes un crédito cotizado?</span>
                <span className="description">
                  Aprovecha nuestro{" "}
                  <strong className="underlined"> Traductor de Crédito </strong>{" "}
                  para entender mejor lo que te están ofreciendo, ¡Sin letra
                  chica!
                </span>
                <ButtonOutlined
                  text="Ir al Traductor de crédito"
                  onClick={() => navigate(Route.toolsCreditTrasnlator)}
                  startIcon={
                    <Icon>
                      <img src={goIcon} />
                    </Icon>
                  }
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className={classes.bottomSection}>
        {/* <ButtonPrimary
          text={"Guardar y volver a mis finanzas"}
          onClick={handleChange}
        />
        <ButtonOutlined
          text={"Ir atras y editar"}
          onClick={function (): void {
            setPage(1);
          }}
        />{" "} */}
        {isMission ? (
          <ButtonPrimary
            text={"Terminar misión"}
            onClick={() => handleClick()}
            secondaryVersion
          />
        ) : (
          <div className="down">
            <ButtonPrimary
              text={"Guardar y volver a mis finanzas"}
              onClick={handleChange}
            />
            <ButtonOutlined
              text={"Ir atras y editar"}
              onClick={function (): void {
                setPage(1);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CreditSimulator2;
